module.exports = __webpack_public_path__ + "static/media/vista_grid.17dc0760.svg";